import { Checkbox, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FlussElementSelection } from "modules/fluss/types/fluss";

interface Props {
    selection: FlussElementSelection;
    modeler: any;
    readOnly: boolean;
    onChanged: () => void;
}

const readsInterrupting = (businessObject: any) => {
    const escalation = businessObject?.eventDefinitions?.[0]?.$type === "bpmn:EscalationEventDefinition";
    return escalation
        ? Object.prototype.hasOwnProperty.call(businessObject || {}, "isInterrupting") && businessObject.isInterrupting === true
        : businessObject?.isInterrupting !== false;
};

export default function EventStartInterruptControl({ selection, modeler, readOnly, onChanged }: Props) {
    const { t } = useTranslation();
    const [interrupting, setInterrupting] = useState(readsInterrupting(selection.businessObject));
    useEffect(() => {
        setInterrupting(readsInterrupting(selection.businessObject));
    }, [selection.id, selection.businessObject]);

    return <FormControlLabel
        control={<Checkbox checked={interrupting} disabled={readOnly} onChange={(event) => {
            setInterrupting(event.target.checked);
            modeler?.get("modeling")?.updateProperties(selection.element, { isInterrupting: event.target.checked });
            onChanged();
        }} />}
        label={t("fluss.node_panel.event_start.interrupting", { defaultValue: "Interromper o processo" })}
    />;
}
